/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Interaction from 'astro/server/interaction';

import * as Coords from 'shared/geo/coords';
import * as Shapes from 'shared/geo/shapes';
import * as Influence from 'astro/util/influence';


export default class extends Interaction
{
  installTargetPlanet (planet)
  {
    for (const coords of Shapes.getCoords(this.cass.target.id, this.cass.shape))
    {
      const target = planet.getZones().getOne(coords.toString());

      target.getAttributes().installInfluence(this.makeInfluenceAttribute());
    }
  }


  installSourcePlanet (planet)
  {
    // no-op.
  }


  makeInfluenceAttribute ()
  {
    return Influence.makeAttack(this.cass.user, this.cass.source, this.cass.args.strength);
  }


  isAggressive ()
  {
    return true;
  }


};


